import { Form, FormField, FormLabel, FormSelect, FormInput, Button } from '../ui';
import type { PromotionCompany, Company } from '../../types/promotion';

interface CompanyFormProps {
  company: PromotionCompany | null;
  companies: Company[];
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onClose: () => void;
}

function CompanyForm({ company, companies = [], onSubmit, isLoading, onClose }: CompanyFormProps) {
  return (
    <Form onSubmit={onSubmit}>
      <FormField>
        <FormLabel htmlFor="company_id" required>
          Empresa
        </FormLabel>
        <FormSelect id="company_id" name="company_id" defaultValue={company?.company_id} required>
          <option value="">Selecione uma empresa</option>
          {Array.isArray(companies) &&
            companies.map(c => (
              <option key={c.id} value={c.id}>
                {c.company_name}
              </option>
            ))}
        </FormSelect>
      </FormField>

      <FormField>
        <FormLabel htmlFor="coupon_quantity" required>
          Quantidade de Cupons
        </FormLabel>
        <FormInput
          type="number"
          id="coupon_quantity"
          name="coupon_quantity"
          min="1"
          defaultValue={company?.coupon_quantity}
          required
        />
      </FormField>

      <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
        <Button type="submit" isLoading={isLoading} className="sm:col-start-2">
          {company ? 'Salvar' : 'Adicionar'}
        </Button>
        <Button type="button" variant="secondary" onClick={onClose} className="sm:col-start-1">
          Cancelar
        </Button>
      </div>
    </Form>
  );
}

export default CompanyForm;
